<template>
  <section>
    <!-- banner部分 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <!-- 人才招聘部分 -->
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col
          cols="11"
          md="10"
          lg="8"
          class="flex-column justify-content-center d-flex job-content"
        >
          <el-collapse
            class="content"
            v-model="activeNames"
            accordion
            @change="handleChange"
          >
            <el-collapse-item
              class="itemHover"
              :name="val.id"
              v-for="val in contentList"
              :key="val.id"
            >
              <template slot="title">
                <span class="icons">
                  <img src="../../assets/images/images/icons_03.png" alt="" />
                </span>
                <h1 class="titleName">{{ val.name }}</h1>
                <span class="pubTime" v-if="val.time">{{
                  formate_Date(val.time)
                }}</span>
              </template>
              <div
                class="jobs1"
                v-show="form.paragraphVoList && form.paragraphVoList.length > 0"
              >
                <div class="title">
                  <span class="online" style="display: none">
                    <span>在线申请</span>
                  </span>
                </div>
                <div
                  class="p-content"
                  v-for="item in form.paragraphVoList"
                  :key="item.id"
                >
                  <pre
                    v-if="item.size == 18"
                    class="hPre"
                    :class="{
                      textBold: item.isBold == '1',
                      textIndentation: item.alignment == '0',
                      textLeft: item.alignment == '1',
                      textCenter: item.alignment == '2',
                      textRight: item.alignment == '3',
                    }"
                    >{{ item.content }}</pre
                  >
                  <pre
                    v-else-if="item.size == 18"
                    class="hPre1"
                    :class="{
                      textBold: item.isBold == '1',
                      textIndentation: item.alignment == '0',
                      textLeft: item.alignment == '1',
                      textCenter: item.alignment == '2',
                      textRight: item.alignment == '3',
                    }"
                    >{{ item.content }}</pre
                  >
                  <pre
                    class="noHpre"
                    v-else
                    :class="{
                      textBold: item.isBold == '1',
                      textIndentation: item.alignment == '0',
                      textLeft: item.alignment == '1',
                      textCenter: item.alignment == '2',
                      textRight: item.alignment == '3',
                    }"
                    >{{ item.content }}</pre
                  >
                  <!-- </p> -->
                  <div class="newsImg" v-show="item.imgSrc">
                    <img :src="item.imgSrc" id="imgId" alt="" />
                  </div>
                  <div class="newsImg" v-if="item.videoSrc">
                    <!-- <video
                controls
                :src="item.videoSrc"
              ></video>     -->
                    <div id="playVideoWindow">
                      <video
                        v-if="videoPlayers"
                        ref="vdo"
                        id="playVideo"
                        class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid"
                        preload="auto"
                        width="100%"
                        style="object-fit: cover"
                      ></video>
                    </div>
                  </div>
                </div>
                <div class="writeBox">
                  <p class="write" v-if="form.author">{{ form.author }}</p>
                  <p class="write" v-if="form.time">{{formateToDate(form.time)}}</p>
                </div>
                <ul
                  class="downloadList1"
                  v-if="form.fileList && form.fileList.length"
                >
                  <li class="downTitle">附:</li>
                  <li
                    class="downItem"
                    v-for="downItem in form.fileList"
                    :key="downItem.id"
                  >
                    <span @click="downLoad(downItem)">{{
                      downItem.fileTitle
                    }}</span>
                  </li>
                </ul>
              </div>
            </el-collapse-item>
          </el-collapse>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col
          cols="11"
          md="10"
          lg="8"
          style="padding: 0% 0 3%"
          class="text-center flex-column justify-content-center d-flex"
        >
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :pager-count="5"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
import axios from "axios";
import qs from "qs";
import utils from "@/utils/commonUrl.js";
import "video.js/dist/video-js.css";
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  filters: {
    boldText: function (value) {
      return value.replace(/(\d+)/g, `<b>$1</b>`);
    },
  },
  data() {
    return {
      videoPlayers: "",
      playVideoUrL: utils.videoUrl,
      currentPage: 1,
      total: 0,
      queryInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      subBannerInfo: {
        img: require("@/assets/images/job-banner.png"),
        title: "人才招聘",
        subTitle: "Recruitment",
      },
      activeNames: "",
      screenWidth: 0,
      contentList: [],
      a: "2323jj哈哈哈哈",
      form: {
        name: "",
        author: "",
        paragraphVoList: [
          // {
          //   alignment: "",
          //   size: "",
          //   content: "",
          //   fileId: "",
          //   isBold: "",
          //   num: 0,
          // },
        ],
      },
      detailId: "",
    };
  },
  watch: {},
  created() {
    this.getJobList();
  },
  beforeDestroy() {
    let that = this;
    if (that.videoPlayers) {
      that.videoPlayers.dispose();
    }
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    this.setReSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setReSize();
    };
  },
  methods: {
    async getJobList() {
      try {
        let { data: res } = await this.$http.get(
          "/server/api/content/recruitment/website/search/getPageList",
          {
            params: this.queryInfo,
          }
        );

        if (res.code === 200) {
          this.contentList = res.content.list;
          this.total = res.content.total;
          // if (this.contentList && this.contentList.length > 0) {
          //   let detailId = this.contentList[0].id;

          //   this.activeNames = !this.activeNames ?  detailId : this.activeNames;
          //   await this.getJobInfo(this.activeNames)
          // }
        }
      } catch (error) {
        return false;
      }
    },
    handlePageChange(val) {
      // console.log("当前页", val);
      this.currentPage = val;
      this.queryInfo.currentPage = val;
      this.getJobList();
    },
    setReSize() {
      if (this.screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/job-banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/job-m.png");
      }
    },
    async getJobInfo(activeNames) {
      try {
        let { data: res } = await this.$http.get(
          "/server/api/content/recruitment/website/search/getInfo",
          {
            params: {
              id: activeNames,
            },
          }
        );

        if (res.code == 200) {
          this.$nextTick(() => {
            this.form.id = res.content.id;
            this.form.name = res.content.name;
            this.form.author = res.content.author;
            this.form.time = res.content.time;
            this.form.fileList = res.content.fileList;
            this.form.paragraphVoList = res.content.paragraphVoList;
            this.form.paragraphVoList.forEach((val, i) => {
              val.alignment = val.alignment + "";
              if (val.fileId.length > 0) {
                let srcPic =
                  utils.imgURL +
                  "/server/api/system/file/getFile?id=" +
                  val.fileId;
                let srcVideo =
                  utils.imgURL +
                  "/server/api/system/file/getFile?id=" +
                  val.fileId;
                if (val.fileType != ".mp4") {
                  val.imgSrc = srcPic;
                } else {
                  this.bofang(val.fileTitle);
                  val.videoSrc = srcVideo;
                }
              }
            });
          });
        }
      } catch (e) {}
    },
    bofang(fileTitle) {
      var that = this;
      that.$nextTick(() => {
        // 加载视频
        // let v_src = that.playVideoUrL + "/banner.m3u8";
        let v_src = that.playVideoUrL +"/" + fileTitle + ".m3u8";
        let options = {
          autoplay: true,
          controls: true,
          // loop: true,
          muted: true,
          // width: window.innerWidth * 0.46,
          // height: 300,
        };
        $("#playVideoWindow").html(
          ` <video ref="vdo" width="100%" style="object-fit: cover;" id="playVideo" class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid" preload="auto"  v-if="videoPlayers"></video>`
        );
        that.videoPlayers = videojs("playVideo", options);
        that.videoPlayers.src({ src: v_src, type: "application/x-mpegURL" });
        // that.videoPlayers.ready(() => {
        //     that.videoPlayers.src({ src: v_src, type: "application/x-mpegURL" });
        // });
        // that.$forceUpdate()
      });
    },

    async handleChange(val) {
      this.activeNames = val;
      console.log("this.ac", this.activeNames);
      if (this.activeNames) {
        await this.getJobInfo(this.activeNames);
      }
    },

    async downLoadPdf(fileName, id) {
      try {
        const { data: res } = await this.$http.get(
          "/server/api/system/file/getFile?id=" + id,
          {
            // responseType: "arraybuffer",
            responseType: "blob",
          }
        );
        if (res) {
          if (fileName.indexOf(".pdf") != -1) {
            const blob = new Blob([res], {
              type: "application/pdf;",
            });
            const objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
          this.$utils.downloadExcel(res, fileName);
        }
      } catch (e) {}
    },
    downLoad(val) {
      const addTypeArray = val.fileType.split(".");
      const addType = addTypeArray[addTypeArray.length - 1];
      if (
        addType === "doc" ||
        addType === "docx" ||
        addType === "xls" ||
        addType === "xlsx"
      ) {
        window.open(
          utils.imgURL + "/server/api/system/file/getFile?id=" + val.id
        );
      } else if (addType === "pdf") {
        this.downLoadPdf(val.fileTitle, val.id);
      }
    },
    formate_Date(time) {
      time = new Date(time);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day + "";
    },
    formateToDate(time) {
      time = new Date(time);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      return year + "年" + month + "月" + day + "日";
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/job-find.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .content {
    margin: calc(50px * 0.5) 0;
  }
  .jobs1 .title .online {
    display: inline-block;
    width: 100px;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
  }
  .jobs1 pre,.newsImg,.writeBox {
    width: 100%;
  }
  
  .jobs1 {
    margin: 10px auto;
  }
  .job-content .icons {
    margin-right: 17px;
  }
  .job-content .icons img {
    margin-top: 20px;
  }
  .job-content h1 {
    font-size: 17px;
    width: calc(100% - 160px);
    line-height: 1.4;
  }
  .job-content .pubTime {
    font-size: 16px;
  }
  .jobs1 .title h2 {
    font-size: 17px;
  }
  .p-content {
    line-height: 2.2;
  }
  .hPre {
    font-size: 16px;
  }
  .hPre1 {
    font-size: 15px;
  }
  .noHpre {
    font-size: 14px;
  }
  .job-content .write {
      font-size: 14px;
      line-height: 2.2;
    }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .content {
    margin: calc(50px * 0.5) 0;
  }
  .jobs1 .title .online {
    display: inline-block;
    width: 100px;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
  }

  .jobs1 {
    margin: 10px auto;
  }
  .job-content .icons {
    margin-right: 17px;
  }
  .job-content .icons img {
    margin-top: 20px;
  }
  .job-content h1 {
    font-size: 18px;
    width: calc(100% - 200px);
    line-height: 1.6;
  }
  .job-content .pubTime {
    font-size: 17px;
  }
  .jobs1 .title h2 {
    font-size: 17px;
  }
  .p-content {
    line-height: 2.3;
  }
  .hPre {
    font-size: 17px;
  }
  .hPre1 {
    font-size: 16px;
  }
  .noHpre {
    font-size: 15px;
  }
  .jobs1 pre,.newsImg,.writeBox {
    width: 90%;
  }
  .job-content .write {
      font-size: 14px;
      line-height: 2.3;
    }
  
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .content {
    margin: calc(50px * 0.5) 0;
  }
  .jobs1 .title .online {
    display: inline-block;
    width: 100px;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
  }
  .jobs1 pre,.newsImg,.writeBox {
    width: 100%;
  }
  .jobs1 {
    margin: 10px auto;
  }
  .job-content .icons {
    margin-right: 17px;
  }
  .job-content .icons img {
    margin-top: 20px;
  }
  .job-content h1 {
    font-size: 20px;
    width: calc(100% - 200px);
    line-height: 1.8;
  }
  .job-content .pubTime {
    font-size: 18px;
  }
  .jobs1 .title h2 {
    font-size: 17px;
  }
  .p-content {
    line-height: 2.3;
  }
  .hPre {
    font-size: 18px;
  }
  .hPre1 {
    font-size: 17px;
  }
  .noHpre {
    font-size: 16px;
  }
  .job-content .write {
      font-size: 15px;
      line-height: 2.3;
    }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  .content {
    margin: calc(50px * 0.5) 0;
  }
  .jobs1 .title .online {
    display: inline-block;
    width: 100px;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
  }
  .jobs1 pre,.newsImg,.writeBox{
    width: 100%;
  }

  .jobs1 {
    margin: 10px auto;
  }
  .job-content .icons {
    margin-right: 17px;
  }
  .job-content .icons img {
    margin-top: 20px;
  }
  .job-content h1 {
    font-size: 22px;
    line-height: 2;
  }
  .job-content .pubTime {
    font-size: 20px;
  }
  .jobs1 .title h2 {
    font-size: 17px;
  }
  .p-content {
    line-height: 2.4;
  }
  .hPre {
    font-size: 18px;
  }
  .hPre1 {
    font-size: 17px;
  }
  .noHpre {
    font-size: 16px;
  }
  .job-content .write {
      font-size: 17px;
      line-height: 2.4;
    }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
